var _g, _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_361_5804)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21.1772,
    cy: 18.9477,
    r: 10.0522,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3702 24.3673C20.2431 24.3673 20.1215 24.3121 20.0386 24.2016L19.4804 23.4555C19.3644 23.3008 19.2096 23.2123 19.0438 23.2013C18.8725 23.1902 18.7123 23.2676 18.5796 23.4058C17.7783 24.2623 17.1704 24.1905 16.8775 24.08C16.5791 23.9639 16.0762 23.5826 16.0762 22.3557V16.1331C16.0762 13.6793 16.7835 12.9333 19.0991 12.9333H23.2715C25.5871 12.9333 26.2944 13.6793 26.2944 16.1331V18.4873C26.2944 18.7139 26.1065 18.9018 25.88 18.9018C25.6534 18.9018 25.4655 18.7139 25.4655 18.4873V16.1331C25.4655 14.138 25.1173 13.7622 23.2715 13.7622H19.0991C17.2533 13.7622 16.9051 14.138 16.9051 16.1331V22.3557C16.9051 22.936 17.0488 23.2565 17.1814 23.3063C17.2809 23.345 17.5517 23.2897 17.9717 22.8421C18.2757 22.5215 18.6736 22.3502 19.0881 22.3723C19.497 22.3944 19.8839 22.61 20.1436 22.9581L20.7073 23.7042C20.8454 23.8865 20.8068 24.1463 20.6244 24.2845C20.5415 24.3452 20.4531 24.3673 20.3702 24.3673Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3893 16.5253H18.9682C18.7416 16.5253 18.5537 16.3374 18.5537 16.1109C18.5537 15.8843 18.7416 15.6964 18.9682 15.6964H23.3893C23.6159 15.6964 23.8038 15.8843 23.8038 16.1109C23.8038 16.3374 23.6159 16.5253 23.3893 16.5253Z",
    fill: "#667085"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8367 18.736H19.5209C19.2943 18.736 19.1064 18.5481 19.1064 18.3216C19.1064 18.095 19.2943 17.9071 19.5209 17.9071H22.8367C23.0633 17.9071 23.2512 18.095 23.2512 18.3216C23.2512 18.5481 23.0633 18.736 22.8367 18.736Z",
    fill: "#667085"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7363 24.2789C22.5263 24.2789 22.3273 24.2015 22.1836 24.0578C22.0123 23.8865 21.935 23.6378 21.9736 23.3781L22.0786 22.632C22.1063 22.4386 22.2223 22.2065 22.3605 22.0683L24.3168 20.112C24.5821 19.8467 24.8418 19.7085 25.1237 19.6809C25.4663 19.6477 25.8089 19.7914 26.1295 20.112C26.45 20.4325 26.5937 20.7696 26.5605 21.1178C26.5329 21.3941 26.3892 21.6593 26.1295 21.9246L24.1731 23.881C24.035 24.0191 23.8029 24.1352 23.6094 24.1628L22.8634 24.2678C22.8192 24.2733 22.7805 24.2789 22.7363 24.2789ZM25.2176 20.5043C25.2121 20.5043 25.2066 20.5043 25.201 20.5043C25.1237 20.5099 25.0187 20.5817 24.9026 20.6978L22.9463 22.6541C22.9297 22.6707 22.9021 22.7259 22.9021 22.7481L22.8026 23.4388L23.4934 23.3394C23.5155 23.3338 23.5708 23.3062 23.5873 23.2896L25.5437 21.3333C25.6597 21.2117 25.7316 21.1122 25.7371 21.0349C25.7482 20.9243 25.6376 20.7917 25.5437 20.6978C25.4553 20.6093 25.3281 20.5043 25.2176 20.5043Z",
    fill: "#667085"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5559 22.328C25.5173 22.328 25.4786 22.3224 25.4454 22.3114C24.7159 22.1069 24.1357 21.5266 23.9312 20.7972C23.8704 20.5761 23.9975 20.3495 24.2186 20.2832C24.4396 20.2224 24.6662 20.3495 24.727 20.5706C24.8541 21.0237 25.2133 21.3829 25.6665 21.5101C25.8875 21.5708 26.0146 21.803 25.9538 22.024C25.9041 22.2064 25.7383 22.328 25.5559 22.328Z",
    fill: "#667085"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_361_5804",
    x: 0.514366,
    y: 0.642793,
    width: 41.3258,
    height: 41.3257,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.35792
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.30532
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_361_5804"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_361_5804",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.130394e03a65dc431108afa473c7be18.svg";
export { ForwardRef as ReactComponent };